module.exports = __webpack_public_path__ + "3ce21b9d0547d61b54195b2a3a9c41b1.png";